import QcImg from "../../Images/QC.jpeg";
export function Quality() {
  return (
    <section className="about-wrap-layout1">
      <div className="container">
        <div className="row">
          <div
            className="about-box-layout2 col-xl-4 col-lg-4 col-12"
            style={{ marginBottom: "20px" }}
          >
            <div className="item-im">
              <img src={QcImg} alt="about" className="img-fluid" />
            </div>
          </div>
          <div className="about-box-layout1 col-xl-8 col-12">
            <div className="item-content" style={{ marginBottom: "0" }}>
              <h2 className="item-title"> Quality </h2>
              <p>
                Krufren's robust quality systems across our various facilities
                ensure that customers can expect the same quality standards
                irrespective of location. While a quality leadership team with
                over 7 years of combined experience anchors our solutions, we
                firmly believe that quality is everyone's responsibility. From
                senior management to the shop floor, we are all equally
                committed to delivering zero-defect products to customers, on
                time, and in full.
              </p>
              <p>
                Quality is a benchmark of perfection for the end-user and we are
                constantly striving to maintain & improve our quality standards
                which makes it easier to get cGMP compliant facility.
              </p>
              <h4>
                {" "}
                To meet the standards that our customers have come to expect
                from us, we:{" "}
              </h4>
              <div className="about-box-layout5 order-xl-12 col-xl-12 col-12">
                <div className="item-content" style={{ marginBottom: "0" }}>
                  <ul className="about-info">
                    <li className="col-12">
                      Develop and implement internationally benchmarked quality
                      management systems (QMS)
                    </li>
                    <li className="col-12">
                      Employ people who commit to our quality culture
                    </li>
                    <li className="col-12">
                      Constant upgradation of our facilities and systems to keep
                      abreast of the latest technology and quality standards to
                      deliver quality products to our customers.
                    </li>
                    <li className="col-12">Invest in world class facilities</li>
                    <li className="col-12">
                      Focus on good documentation practices
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
